import { useAuthStore } from '..';

export const performAuthStoreCleanupFunctions = () => {
  useAuthStore.getState().cleanupFunctions?.forEach(fn => fn());
  useAuthStore.setState(state => ({
    ...state,
    cleanupFunctions: []
  }));
};
